module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkBAMAAACCzIhnAAAAElBMVEXVKx7ZPjLfX1blenL////vrKeNpdPTAAAAVUlEQVR4Ae3XRQGEUAAA0c2wFMACYAWwBvSvgru7ztyQd/v6I6In9JfzpNnE8vJcCAQC6SaYZUFB/Oqd3kNUbzTnaAKBQLZP5CpWSwgEsuYy8oCIKAJDBRPqLIwskQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ch.png
// module id = UkWv
// module chunks = 0